import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const freeReturnsOnBasketSelector = createSelector(testTargetOffersSelector, offers => offers.freeReturnsOnBasket || Empty.Object);

export { freeReturnsOnBasketSelector };
